let _ = t => t,
  _t;
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import { mediaQuery, css } from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Flex } from 'foundations-components/components/Flex';
import { PublicCatalogResultsDisplay } from '../publicCatalog/components/PublicCatalogResults';
import { useGetPopularCoursesForHomepage } from './popularCoursesHooks';
import { getPublicLang } from 'academy-common-lib/utils/url';
import usageTracker from '../../utils/usageTracker';
import { ThemedPrimaryRouterButton, ThemedRouterLink } from '../../components/ThemedComponents';
import { View } from 'foundations-components/components/View';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPopularCoursesSection = styledWithTheme.section(_t || (_t = _`
  background-color: ${0};
  padding-top: ${0};

  ${0}
`), ({
  theme: trellisTheme
}) => trellisTheme.color['do-not-use-gypsum'], ({
  theme: trellisTheme
}) => trellisTheme.space['1400'], mediaQuery('notMobile', css(["padding-top:128px;"])));
const CoursesCategoryLinks = {
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  SOFTWARE: 'software'
};
const CategoryLink = ({
  category
}) => {
  return /*#__PURE__*/_jsx(ThemedRouterLink, {
    onClick: () => usageTracker.track('interaction', {
      action: 'popular-courses-category-link-click',
      value: category
    }),
    padding: "400",
    to: `/courses/${CoursesCategoryLinks[category]}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `academyPublic.homepage.popularCourses.${category}`
    })
  });
};
const PopularCoursesSection = () => {
  const {
    popularCoursesData,
    popularCoursesError,
    popularCoursesLoading
  } = useGetPopularCoursesForHomepage();
  const handleViewAllCoursesLinkClick = () => {
    usageTracker.track('interaction', {
      action: 'popular-courses-view-all-click'
    });
  };
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledPopularCoursesSection, {
      children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
        children: [/*#__PURE__*/_jsx(H2, {
          marginBlockEnd: "800",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.homepage.popularCourses.heading"
          })
        }), /*#__PURE__*/_jsx(Flex, {
          justifyContent: "center",
          marginBlockEnd: "1200",
          children: Object.keys(CoursesCategoryLinks).map(category => {
            return /*#__PURE__*/_jsx(CategoryLink, {
              category: category
            }, category);
          })
        }), /*#__PURE__*/_jsx(PublicCatalogResultsDisplay, {
          data: popularCoursesData,
          disablePaginator: true,
          disableSchema: true,
          error: popularCoursesError,
          language: getPublicLang(),
          loading: popularCoursesLoading
        }), /*#__PURE__*/_jsx(View, {
          textAlign: "center",
          children: /*#__PURE__*/_jsx(ThemedPrimaryRouterButton, {
            onClick: handleViewAllCoursesLinkClick,
            to: `/courses`,
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.homepage.popularCourses.viewAll"
            })
          })
        })]
      })
    })
  );
};
export default PopularCoursesSection;